import api from "@/app/api";
import { useApiCall } from "@/app/api/apiCall";
import { useSession } from "@/app/auth/SessionProvider";
import { Footer } from "@/app/components/Footer";
import { PrivateContext } from "@/app/components/PrivateContextLoader";
import { links, NavContext } from "@/app/NavContext";
import { Button } from "@chakra-ui/react";
import { AppShellProps } from "@saas-ui/core";
import {
  AppShell,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarLink,
} from "@saas-ui/react";
import React, { useContext, useState } from "react";
import { useLocation } from "react-router";

export default function AppLayout({
  children,
  footer,
  navbarContent,
  ...rest
}: AppShellProps & { navbarContent?: React.ReactNode }) {
  const { setSession } = useSession();
  const { user } = useContext(PrivateContext);
  const { pathname } = useLocation();
  const { navLinks } = useContext(NavContext);
  const handle = useApiCall();
  const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);

  const logout = async () => {
    await handle(
      () => api.logout(),
      () => {
        setSession(false);
        setIsLoggingOut(false);
      },
      () => {
        setIsLoggingOut(false);
      }
    );
  };

  return (
    <AppShell
      {...rest}
      height="$100vh"
      navbar={
        <Navbar borderBottomWidth="1px" position="sticky" top="0">
          <NavbarBrand>
            <img
              width={25}
              alt="PHAR+logo-P.png"
              className="loaded"
              src="/phar.png"
            />
          </NavbarBrand>
          <NavbarContent justifyContent="flex-start">
            <NavbarItem>
              {links
                .filter(({ adminOnly }) => !adminOnly || user?.is_admin)
                .map(({ href, label }) => (
                  <NavbarLink
                    key={href}
                    isActive={pathname === href}
                    href={navLinks[href]}
                  >
                    {label}
                  </NavbarLink>
                ))}
            </NavbarItem>
          </NavbarContent>
          {!!navbarContent && (
            <NavbarContent justifyContent="center">
              {navbarContent}
            </NavbarContent>
          )}
          <NavbarContent justifyContent="flex-end" spacing="2">
            <NavbarItem>
              <Button disabled={isLoggingOut} onClick={() => logout()}>
                Logout
              </Button>
            </NavbarItem>
          </NavbarContent>
        </Navbar>
      }
    >
      {children}
      {!!footer && <Footer>{footer}</Footer>}
    </AppShell>
  );
}
